module.exports = __webpack_public_path__ + "static/media/menu.cccf5299.svg";